import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5e7d1c92&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=5e7d1c92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d1c92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e7d1c92')) {
      api.createRecord('5e7d1c92', component.options)
    } else {
      api.reload('5e7d1c92', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=5e7d1c92&scoped=true", function () {
      api.rerender('5e7d1c92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activiti/detail.vue"
export default component.exports